module.exports = __webpack_public_path__ + "static/media/LiveClassesEducation.2d54faa1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/liveClass/LiveClassesEducation.webp
// module id = 869
// module chunks = 7